module.exports = __webpack_public_path__ + "assets/images/project/play-icon.svg?v=f6b59f8a";